export default __webpack_public_path__ + "static/16-11ef4ab92c20070570f046993d403c59.png";